import axios from 'axios';
import { getAuthHeader } from './headers';
import {
  requestInterceptor,
  errorResponseInterceptor,
} from '@/helpers/api/refreshTokenInterceptors';

export const instance = axios.create({
  baseURL: import.meta.env.VITE_AUTH_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});

instance.interceptors.request.use((config) => requestInterceptor(config));

instance.interceptors.response.use(
  (response) => response,
  (error) => errorResponseInterceptor(error)
);

// TODO: deprecate this instance in favor of the new auth-service instance
export const legacyInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
});

legacyInstance.interceptors.request.use((config) => requestInterceptor(config));

legacyInstance.interceptors.response.use(
  (response) => response,
  (error) => errorResponseInterceptor(error)
);

export const generateKeys = () => {
  return instance.post('auth/keys');
};

export const getAuthenticatedUser = (data) => {
  return instance.post('auth/user', data);
};

export const getUserData = () => {
  return instance.get('auth/user', { headers: getAuthHeader() });
};

// Migrates old write keys to new JWT tokens
export const getToken = (writeKey) => {
  return instance.post(
    'auth/token',
    {},
    {
      headers: { Authorization: `Bearer ${writeKey}` },
    }
  );
};

export const logUserOut = () => {
  return instance.delete('auth/token', { headers: getAuthHeader() });
};

export const deleteKeys = (data) => {
  return instance.delete('auth/keys', {
    data,
  });
};

export const storePreBuiltComponentJson = (data) => {
  return legacyInstance.post('store-pre-built-components', data);
};
